import { BasicItem } from './basic-item';


export class BaseResponse {

    public static ACCEPTED = "Accepted";
    
    response  : Response;

    id      : number;
    code    : string;
    name    : string;
    
    strArg1 : string;
    strArg2 : string;
    strArg3 : string;
    strArg4 : string;


    lngArg1 : number;
    lngArg2 : number;

    nbrArg1 : number;
    nbrArg2 : number;

    dteArg1 : Date;
    dteArg2 : Date;

    items   : Array<BasicItem>;

}
